// extracted by mini-css-extract-plugin
export default {"Spinner":"withSpinner_Spinner__gxgOr","donut":"withSpinner_donut__xFf48","spin":"withSpinner_spin__rtARY","AuthLayout":"withSpinner_AuthLayout__Y4+Wm"};